import { FC } from 'react';

import { Icon } from './Icon';
import { SvgIcon } from './SvgIcon.type';

export const IconDoor: FC<SvgIcon> = (props) => (
  <Icon {...props} viewBox="0 0 24 24" name="door">
    <path d="M13.4 13.4h2.7v1.2h-2.7v-1.2Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5 6.4A1.6 1.6 0 0 0 8.9 8v2a1.6 1.6 0 0 0 1.6 1.6h5.87c1.47 0 2.162-1.818 1.063-2.796l-2.25-2A1.6 1.6 0 0 0 14.12 6.4H10.5ZM10.1 8c0-.22.179-.4.4-.4h3.62a.4.4 0 0 1 .265.101l2.25 2a.4.4 0 0 1-.265.699H10.5a.4.4 0 0 1-.4-.4V8Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.9 6a2.6 2.6 0 0 1 2.6-2.6h6.171a2.6 2.6 0 0 1 1.839.762l3.828 3.828a2.6 2.6 0 0 1 .762 1.838v4.787c0 .544-.44.985-.985.985a4.015 4.015 0 0 0-4.015 4.015c0 .544-.44.985-.985.985H8.5c-1.23 0-2.26-.853-2.53-2H5A1.6 1.6 0 0 1 3.4 17v-1A1.6 1.6 0 0 1 5 14.4h.9v-3.8H5A1.6 1.6 0 0 1 3.4 9V8A1.6 1.6 0 0 1 5 6.4h.9V6Zm0 9.6H5a.4.4 0 0 0-.4.4v1c0 .22.179.4.4.4h.9v-1.8Zm0-8v1.8H5a.4.4 0 0 1-.4-.4V8c0-.22.179-.4.4-.4h.9Zm2.6-3A1.4 1.4 0 0 0 7.1 6v12a1.4 1.4 0 0 0 1.4 1.4h6.404a5.216 5.216 0 0 1 4.996-4.996V9.828a1.4 1.4 0 0 0-.41-.99L15.66 5.01a1.4 1.4 0 0 0-.99-.41H8.5Z"
    />
  </Icon>
);
